import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {Breadcrumb, Container} from 'react-bootstrap'
import {deslectEwUser} from '../action/userActions'
import {setEWGroupNuLL} from '../action/ewGroupActions'
class BreadcrumbNav extends Component {
  
    render(){
        console.log('path', this.props.history.location.pathname)
        const HomeNav = (()=>{
            switch (this.props.history.location.pathname){
                case '/' :
                return<Container>
                           <Breadcrumb>
                           <Breadcrumb.Item active >Users</Breadcrumb.Item>
      
                    </Breadcrumb> 
         
                </Container>
                case '/create' :
                return <Container>
                      <Breadcrumb>
                <Breadcrumb.Item onClick={()=>{
                    this.props.dispatch(setEWGroupNuLL())
                    this.props.dispatch(deslectEwUser())

                    this.props.history.push('/')
                    
                    }} >Users</Breadcrumb.Item>
                <Breadcrumb.Item active  >{this.props.user ? 
                this.props.user['firstName'] + ' ' + this.props.user['lastName']
               : 'Add User'}</Breadcrumb.Item>
               

         </Breadcrumb>

                </Container>
              
            case '/changepassword':
            return ''
            case '/newpw':
                return ''
            
         
            default:
            return <Container>
                       <Breadcrumb>
                            <Breadcrumb.Item active onClick={()=>{this.props.history.push('/')}} >Users</Breadcrumb.Item>
                    </Breadcrumb>
            </Container> 
     
            }

        })
        var crumbs = []

      
        return( <HomeNav />)
    }
}
const mapStateToProps = state => (
    {
    user : state.acct.user.selectedUser,
 
  });

export default withRouter(connect(mapStateToProps)(BreadcrumbNav))